



































import { Component, Vue } from 'vue-property-decorator';
import TaskAttributeColumn from '@/components/config/configList/TaskAttributeColumn.vue';
import { vxm } from '@/store';
import { AllUpdateProjectCustomAttributesParam, ProjectCustomAttributeType } from '@/@types/Project';
import { AttributeCd, ATTRIBUTE_STYLE } from '@/@types/constant';

@Component({
  components: {
    TaskAttributeColumn,
  },
})
export default class TaskAttributeList extends Vue {
  private attributes: ProjectCustomAttributeType[] = [];
  private isUpdating: boolean = false;

  private async mounted() {
    const currentProjectId = 1; // TODO: authStoreからcurrentProjectIdが取れるようになったら修正
    await vxm.theoryApi.projectsStore.fetchProjectAll(currentProjectId);
    await vxm.theoryApi.projectsStore.fetchTaskAttributeValueOptions(currentProjectId);
    const currentProject = vxm.theoryApi.projectsStore.getProjectAll;
    const attributeOptions = vxm.theoryApi.projectsStore.getTaskAttributeValueOptions?.results;
    if (currentProject && attributeOptions) {
      // customAttributeを愚直に取り出して扱いやすいオブジェクトに変換する
      this.attributes = [
        {
          attributeCd: AttributeCd.category,
          attributeName: 'カテゴリー',
          attributeStyle: ATTRIBUTE_STYLE.OPTION,
          attributeDisplayStyle: currentProject.categoryAttributeDisplayStyle,
          attributeDisplayFlag: currentProject.categoryAttributeDisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.category),
        },
        {
          attributeCd: AttributeCd.priority,
          attributeName: '優先度',
          attributeStyle: ATTRIBUTE_STYLE.OPTION,
          attributeDisplayStyle: currentProject.priorityAttributeDisplayStyle,
          attributeDisplayFlag: currentProject.priorityAttributeDisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.priority),
        },
        {
          attributeCd: AttributeCd.status,
          attributeName: 'ステータス',
          attributeStyle: ATTRIBUTE_STYLE.OPTION,
          attributeDisplayStyle: currentProject.statusAttributeDisplayStyle,
          attributeDisplayFlag: currentProject.statusAttributeDisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.status),
        },
        {
          attributeCd: AttributeCd.attribute1,
          attributeName: currentProject.customAttribute1Name,
          attributeStyle: currentProject.customAttribute1Style,
          attributeDisplayStyle: currentProject.customAttribute1DisplayStyle,
          attributeDisplayFlag: currentProject.customAttribute1DisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.attribute1),
        },
        {
          attributeCd: AttributeCd.attribute2,
          attributeName: currentProject.customAttribute2Name,
          attributeStyle: currentProject.customAttribute2Style,
          attributeDisplayStyle: currentProject.customAttribute2DisplayStyle,
          attributeDisplayFlag: currentProject.customAttribute2DisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.attribute2),
        },
        {
          attributeCd: AttributeCd.attribute3,
          attributeName: currentProject.customAttribute3Name,
          attributeStyle: currentProject.customAttribute3Style,
          attributeDisplayStyle: currentProject.customAttribute3DisplayStyle,
          attributeDisplayFlag: currentProject.customAttribute3DisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.attribute3),
        },
        {
          attributeCd: AttributeCd.attribute4,
          attributeName: currentProject.customAttribute4Name,
          attributeStyle: currentProject.customAttribute4Style,
          attributeDisplayStyle: currentProject.customAttribute4DisplayStyle,
          attributeDisplayFlag: currentProject.customAttribute4DisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.attribute4),
        },
        {
          attributeCd: AttributeCd.attribute5,
          attributeName: currentProject.customAttribute5Name,
          attributeStyle: currentProject.customAttribute5Style,
          attributeDisplayStyle: currentProject.customAttribute5DisplayStyle,
          attributeDisplayFlag: currentProject.customAttribute5DisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.attribute5),
        },
        {
          attributeCd: AttributeCd.attribute6,
          attributeName: currentProject.customAttribute6Name,
          attributeStyle: currentProject.customAttribute6Style,
          attributeDisplayStyle: currentProject.customAttribute6DisplayStyle,
          attributeDisplayFlag: currentProject.customAttribute6DisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.attribute6),
        },
        {
          attributeCd: AttributeCd.attribute7,
          attributeName: currentProject.customAttribute7Name,
          attributeStyle: currentProject.customAttribute7Style,
          attributeDisplayStyle: currentProject.customAttribute7DisplayStyle,
          attributeDisplayFlag: currentProject.customAttribute7DisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.attribute7),
        },
        {
          attributeCd: AttributeCd.attribute8,
          attributeName: currentProject.customAttribute8Name,
          attributeStyle: currentProject.customAttribute8Style,
          attributeDisplayStyle: currentProject.customAttribute8DisplayStyle,
          attributeDisplayFlag: currentProject.customAttribute8DisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.attribute8),
        },
        {
          attributeCd: AttributeCd.attribute9,
          attributeName: currentProject.customAttribute9Name,
          attributeStyle: currentProject.customAttribute9Style,
          attributeDisplayStyle: currentProject.customAttribute9DisplayStyle,
          attributeDisplayFlag: currentProject.customAttribute9DisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.attribute9),
        },
        {
          attributeCd: AttributeCd.attribute10,
          attributeName: currentProject.customAttribute10Name,
          attributeStyle: currentProject.customAttribute10Style,
          attributeDisplayStyle: currentProject.customAttribute10DisplayStyle,
          attributeDisplayFlag: currentProject.customAttribute10DisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.attribute10),
        },
        {
          attributeCd: AttributeCd.attribute11,
          attributeName: currentProject.customAttribute11Name,
          attributeStyle: currentProject.customAttribute11Style,
          attributeDisplayStyle: currentProject.customAttribute11DisplayStyle,
          attributeDisplayFlag: currentProject.customAttribute11DisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.attribute11),
        },
        {
          attributeCd: AttributeCd.attribute12,
          attributeName: currentProject.customAttribute12Name,
          attributeStyle: currentProject.customAttribute12Style,
          attributeDisplayStyle: currentProject.customAttribute12DisplayStyle,
          attributeDisplayFlag: currentProject.customAttribute12DisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.attribute12),
        },
        {
          attributeCd: AttributeCd.attribute13,
          attributeName: currentProject.customAttribute13Name,
          attributeStyle: currentProject.customAttribute13Style,
          attributeDisplayStyle: currentProject.customAttribute13DisplayStyle,
          attributeDisplayFlag: currentProject.customAttribute13DisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.attribute13),
        },
        {
          attributeCd: AttributeCd.attribute14,
          attributeName: currentProject.customAttribute14Name,
          attributeStyle: currentProject.customAttribute14Style,
          attributeDisplayStyle: currentProject.customAttribute14DisplayStyle,
          attributeDisplayFlag: currentProject.customAttribute14DisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.attribute14),
        },
        {
          attributeCd: AttributeCd.attribute15,
          attributeName: currentProject.customAttribute15Name,
          attributeStyle: currentProject.customAttribute15Style,
          attributeDisplayStyle: currentProject.customAttribute15DisplayStyle,
          attributeDisplayFlag: currentProject.customAttribute15DisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.attribute15),
        },
        {
          attributeCd: AttributeCd.attribute16,
          attributeName: currentProject.customAttribute16Name,
          attributeStyle: currentProject.customAttribute16Style,
          attributeDisplayStyle: currentProject.customAttribute16DisplayStyle,
          attributeDisplayFlag: currentProject.customAttribute16DisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.attribute16),
        },
        {
          attributeCd: AttributeCd.attribute17,
          attributeName: currentProject.customAttribute17Name,
          attributeStyle: currentProject.customAttribute17Style,
          attributeDisplayStyle: currentProject.customAttribute17DisplayStyle,
          attributeDisplayFlag: currentProject.customAttribute17DisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.attribute17),
        },
        {
          attributeCd: AttributeCd.attribute18,
          attributeName: currentProject.customAttribute18Name,
          attributeStyle: currentProject.customAttribute18Style,
          attributeDisplayStyle: currentProject.customAttribute18DisplayStyle,
          attributeDisplayFlag: currentProject.customAttribute18DisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.attribute18),
        },
        {
          attributeCd: AttributeCd.attribute19,
          attributeName: currentProject.customAttribute19Name,
          attributeStyle: currentProject.customAttribute19Style,
          attributeDisplayStyle: currentProject.customAttribute19DisplayStyle,
          attributeDisplayFlag: currentProject.customAttribute19DisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.attribute19),
        },
        {
          attributeCd: AttributeCd.attribute20,
          attributeName: currentProject.customAttribute20Name,
          attributeStyle: currentProject.customAttribute20Style,
          attributeDisplayStyle: currentProject.customAttribute20DisplayStyle,
          attributeDisplayFlag: currentProject.customAttribute20DisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.attribute20),
        },
        {
          attributeCd: AttributeCd.attribute21,
          attributeName: currentProject.customAttribute21Name,
          attributeStyle: currentProject.customAttribute21Style,
          attributeDisplayStyle: currentProject.customAttribute21DisplayStyle,
          attributeDisplayFlag: currentProject.customAttribute21DisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.attribute21),
        },
        {
          attributeCd: AttributeCd.attribute22,
          attributeName: currentProject.customAttribute22Name,
          attributeStyle: currentProject.customAttribute22Style,
          attributeDisplayStyle: currentProject.customAttribute22DisplayStyle,
          attributeDisplayFlag: currentProject.customAttribute22DisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.attribute22),
        },
        {
          attributeCd: AttributeCd.attribute23,
          attributeName: currentProject.customAttribute23Name,
          attributeStyle: currentProject.customAttribute23Style,
          attributeDisplayStyle: currentProject.customAttribute23DisplayStyle,
          attributeDisplayFlag: currentProject.customAttribute23DisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.attribute23),
        },
        {
          attributeCd: AttributeCd.attribute24,
          attributeName: currentProject.customAttribute24Name,
          attributeStyle: currentProject.customAttribute24Style,
          attributeDisplayStyle: currentProject.customAttribute24DisplayStyle,
          attributeDisplayFlag: currentProject.customAttribute24DisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.attribute24),
        },
        {
          attributeCd: AttributeCd.attribute25,
          attributeName: currentProject.customAttribute25Name,
          attributeStyle: currentProject.customAttribute25Style,
          attributeDisplayStyle: currentProject.customAttribute25DisplayStyle,
          attributeDisplayFlag: currentProject.customAttribute25DisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.attribute25),
        },
        {
          attributeCd: AttributeCd.attribute26,
          attributeName: currentProject.customAttribute26Name,
          attributeStyle: currentProject.customAttribute26Style,
          attributeDisplayStyle: currentProject.customAttribute26DisplayStyle,
          attributeDisplayFlag: currentProject.customAttribute26DisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.attribute26),
        },
        {
          attributeCd: AttributeCd.attribute27,
          attributeName: currentProject.customAttribute27Name,
          attributeStyle: currentProject.customAttribute27Style,
          attributeDisplayStyle: currentProject.customAttribute27DisplayStyle,
          attributeDisplayFlag: currentProject.customAttribute27DisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.attribute27),
        },
        {
          attributeCd: AttributeCd.attribute28,
          attributeName: currentProject.customAttribute28Name,
          attributeStyle: currentProject.customAttribute28Style,
          attributeDisplayStyle: currentProject.customAttribute28DisplayStyle,
          attributeDisplayFlag: currentProject.customAttribute28DisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.attribute28),
        },
        {
          attributeCd: AttributeCd.attribute29,
          attributeName: currentProject.customAttribute29Name,
          attributeStyle: currentProject.customAttribute29Style,
          attributeDisplayStyle: currentProject.customAttribute29DisplayStyle,
          attributeDisplayFlag: currentProject.customAttribute29DisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.attribute29),
        },
        {
          attributeCd: AttributeCd.attribute30,
          attributeName: currentProject.customAttribute30Name,
          attributeStyle: currentProject.customAttribute30Style,
          attributeDisplayStyle: currentProject.customAttribute30DisplayStyle,
          attributeDisplayFlag: currentProject.customAttribute30DisplayFlag,
          attributeOptions: attributeOptions.filter((v) => v.attributeCd === AttributeCd.attribute30),
        },
      ]
    }
  }

  private async updateCustomAttributes() {
    this.isUpdating = true;
    const currentProjectId = 1; // TODO: authStoreからcurrentProjectIdが取れるようになったら修正
    const updateData: AllUpdateProjectCustomAttributesParam = {
      categoryAttributeDisplayStyle: this.attributes[0].attributeDisplayStyle!,
      categoryAttributeDisplayFlag: Boolean(this.attributes[0].attributeDisplayFlag),
      priorityAttributeDisplayStyle: this.attributes[1].attributeDisplayStyle!,
      priorityAttributeDisplayFlag: Boolean(this.attributes[1].attributeDisplayFlag),
      statusAttributeDisplayStyle: this.attributes[2].attributeDisplayStyle!,
      statusAttributeDisplayFlag: Boolean(this.attributes[2].attributeDisplayFlag),
      customAttribute1Name: this.attributes[3].attributeName,
      customAttribute1Style: this.attributes[3].attributeStyle,
      customAttribute1DisplayStyle: this.attributes[3].attributeDisplayStyle,
      customAttribute1DisplayFlag: Boolean(this.attributes[3].attributeDisplayFlag),
      customAttribute2Name: this.attributes[4].attributeName,
      customAttribute2Style: this.attributes[4].attributeStyle,
      customAttribute2DisplayStyle: this.attributes[4].attributeDisplayStyle,
      customAttribute2DisplayFlag: Boolean(this.attributes[4].attributeDisplayFlag),
      customAttribute3Name: this.attributes[5].attributeName,
      customAttribute3Style: this.attributes[5].attributeStyle,
      customAttribute3DisplayStyle: this.attributes[5].attributeDisplayStyle,
      customAttribute3DisplayFlag: Boolean(this.attributes[5].attributeDisplayFlag),
      customAttribute4Name: this.attributes[6].attributeName,
      customAttribute4Style: this.attributes[6].attributeStyle,
      customAttribute4DisplayStyle: this.attributes[6].attributeDisplayStyle,
      customAttribute4DisplayFlag: Boolean(this.attributes[6].attributeDisplayFlag),
      customAttribute5Name: this.attributes[7].attributeName,
      customAttribute5Style: this.attributes[7].attributeStyle,
      customAttribute5DisplayStyle: this.attributes[7].attributeDisplayStyle,
      customAttribute5DisplayFlag: Boolean(this.attributes[7].attributeDisplayFlag),
      customAttribute6Name: this.attributes[8].attributeName,
      customAttribute6Style: this.attributes[8].attributeStyle,
      customAttribute6DisplayStyle: this.attributes[8].attributeDisplayStyle,
      customAttribute6DisplayFlag: Boolean(this.attributes[8].attributeDisplayFlag),
      customAttribute7Name: this.attributes[9].attributeName,
      customAttribute7Style: this.attributes[9].attributeStyle,
      customAttribute7DisplayStyle: this.attributes[9].attributeDisplayStyle,
      customAttribute7DisplayFlag: Boolean(this.attributes[9].attributeDisplayFlag),
      customAttribute8Name: this.attributes[10].attributeName,
      customAttribute8Style: this.attributes[10].attributeStyle,
      customAttribute8DisplayStyle: this.attributes[10].attributeDisplayStyle,
      customAttribute8DisplayFlag: Boolean(this.attributes[10].attributeDisplayFlag),
      customAttribute9Name: this.attributes[11].attributeName,
      customAttribute9Style: this.attributes[11].attributeStyle,
      customAttribute9DisplayStyle: this.attributes[11].attributeDisplayStyle,
      customAttribute9DisplayFlag: Boolean(this.attributes[11].attributeDisplayFlag),
      customAttribute10Name: this.attributes[12].attributeName,
      customAttribute10Style: this.attributes[12].attributeStyle,
      customAttribute10DisplayStyle: this.attributes[12].attributeDisplayStyle,
      customAttribute10DisplayFlag: Boolean(this.attributes[12].attributeDisplayFlag),
      customAttribute11Name: this.attributes[13].attributeName,
      customAttribute11Style: this.attributes[13].attributeStyle,
      customAttribute11DisplayStyle: this.attributes[13].attributeDisplayStyle,
      customAttribute11DisplayFlag: Boolean(this.attributes[13].attributeDisplayFlag),
      customAttribute12Name: this.attributes[14].attributeName,
      customAttribute12Style: this.attributes[14].attributeStyle,
      customAttribute12DisplayStyle: this.attributes[14].attributeDisplayStyle,
      customAttribute12DisplayFlag: Boolean(this.attributes[14].attributeDisplayFlag),
      customAttribute13Name: this.attributes[15].attributeName,
      customAttribute13Style: this.attributes[15].attributeStyle,
      customAttribute13DisplayStyle: this.attributes[15].attributeDisplayStyle,
      customAttribute13DisplayFlag: Boolean(this.attributes[15].attributeDisplayFlag),
      customAttribute14Name: this.attributes[16].attributeName,
      customAttribute14Style: this.attributes[16].attributeStyle,
      customAttribute14DisplayStyle: this.attributes[16].attributeDisplayStyle,
      customAttribute14DisplayFlag: Boolean(this.attributes[16].attributeDisplayFlag),
      customAttribute15Name: this.attributes[17].attributeName,
      customAttribute15Style: this.attributes[17].attributeStyle,
      customAttribute15DisplayStyle: this.attributes[17].attributeDisplayStyle,
      customAttribute15DisplayFlag: Boolean(this.attributes[17].attributeDisplayFlag),
      customAttribute16Name: this.attributes[18].attributeName,
      customAttribute16Style: this.attributes[18].attributeStyle,
      customAttribute16DisplayStyle: this.attributes[18].attributeDisplayStyle,
      customAttribute16DisplayFlag: Boolean(this.attributes[18].attributeDisplayFlag),
      customAttribute17Name: this.attributes[19].attributeName,
      customAttribute17Style: this.attributes[19].attributeStyle,
      customAttribute17DisplayStyle: this.attributes[19].attributeDisplayStyle,
      customAttribute17DisplayFlag: Boolean(this.attributes[19].attributeDisplayFlag),
      customAttribute18Name: this.attributes[20].attributeName,
      customAttribute18Style: this.attributes[20].attributeStyle,
      customAttribute18DisplayStyle: this.attributes[20].attributeDisplayStyle,
      customAttribute18DisplayFlag: Boolean(this.attributes[20].attributeDisplayFlag),
      customAttribute19Name: this.attributes[21].attributeName,
      customAttribute19Style: this.attributes[21].attributeStyle,
      customAttribute19DisplayStyle: this.attributes[21].attributeDisplayStyle,
      customAttribute19DisplayFlag: Boolean(this.attributes[21].attributeDisplayFlag),
      customAttribute20Name: this.attributes[22].attributeName,
      customAttribute20Style: this.attributes[22].attributeStyle,
      customAttribute20DisplayStyle: this.attributes[22].attributeDisplayStyle,
      customAttribute20DisplayFlag: Boolean(this.attributes[22].attributeDisplayFlag),
      customAttribute21Name: this.attributes[23].attributeName,
      customAttribute21Style: this.attributes[23].attributeStyle,
      customAttribute21DisplayStyle: this.attributes[23].attributeDisplayStyle,
      customAttribute21DisplayFlag: Boolean(this.attributes[23].attributeDisplayFlag),
      customAttribute22Name: this.attributes[24].attributeName,
      customAttribute22Style: this.attributes[24].attributeStyle,
      customAttribute22DisplayStyle: this.attributes[24].attributeDisplayStyle,
      customAttribute22DisplayFlag: Boolean(this.attributes[24].attributeDisplayFlag),
      customAttribute23Name: this.attributes[25].attributeName,
      customAttribute23Style: this.attributes[25].attributeStyle,
      customAttribute23DisplayStyle: this.attributes[25].attributeDisplayStyle,
      customAttribute23DisplayFlag: Boolean(this.attributes[25].attributeDisplayFlag),
      customAttribute24Name: this.attributes[26].attributeName,
      customAttribute24Style: this.attributes[26].attributeStyle,
      customAttribute24DisplayStyle: this.attributes[26].attributeDisplayStyle,
      customAttribute24DisplayFlag: Boolean(this.attributes[26].attributeDisplayFlag),
      customAttribute25Name: this.attributes[27].attributeName,
      customAttribute25Style: this.attributes[27].attributeStyle,
      customAttribute25DisplayStyle: this.attributes[27].attributeDisplayStyle,
      customAttribute25DisplayFlag: Boolean(this.attributes[27].attributeDisplayFlag),
      customAttribute26Name: this.attributes[28].attributeName,
      customAttribute26Style: this.attributes[28].attributeStyle,
      customAttribute26DisplayStyle: this.attributes[28].attributeDisplayStyle,
      customAttribute26DisplayFlag: Boolean(this.attributes[28].attributeDisplayFlag),
      customAttribute27Name: this.attributes[29].attributeName,
      customAttribute27Style: this.attributes[29].attributeStyle,
      customAttribute27DisplayStyle: this.attributes[29].attributeDisplayStyle,
      customAttribute27DisplayFlag: Boolean(this.attributes[29].attributeDisplayFlag),
      customAttribute28Name: this.attributes[30].attributeName,
      customAttribute28Style: this.attributes[30].attributeStyle,
      customAttribute28DisplayStyle: this.attributes[30].attributeDisplayStyle,
      customAttribute28DisplayFlag: Boolean(this.attributes[30].attributeDisplayFlag),
      customAttribute29Name: this.attributes[31].attributeName,
      customAttribute29Style: this.attributes[31].attributeStyle,
      customAttribute29DisplayStyle: this.attributes[31].attributeDisplayStyle,
      customAttribute29DisplayFlag: Boolean(this.attributes[31].attributeDisplayFlag),
      customAttribute30Name: this.attributes[32].attributeName,
      customAttribute30Style: this.attributes[32].attributeStyle,
      customAttribute30DisplayStyle: this.attributes[32].attributeDisplayStyle,
      customAttribute30DisplayFlag: Boolean(this.attributes[32].attributeDisplayFlag),
    };
    await vxm.theoryApi.projectsStore.updateCustomAttributes({
      projectId: currentProjectId,
      data: updateData,
    });
    this.isUpdating = false;
  }

  private async deleteOption(id: number) {
    const currentProjectId = 1; // TODO: authStoreからcurrentProjectIdが取れるようになったら修正
    await vxm.theoryApi.projectsStore.deleteTaskAttributeValueOption({
      projectId: currentProjectId,
      taskAttributeValueOptionId: id,
    });
  }
}
